import { createSelector } from 'reselect';

import getOptionsSlice from '@/state/selectors/options/get-options-slice';

const getHostDomain = createSelector(
	[getOptionsSlice],
	({ hostDomain }) => hostDomain,
);

export default getHostDomain;
